import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Checkbox, Form, Popconfirm, Icon, Row, Col } from 'antd';
import { Spin, Form as AntForm } from 'antd';
import { Field, FormSection, formValueSelector, reduxForm, change } from 'redux-form';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { MaterialInput, MaterialInputSection } from '../../components/inputs/MaterialStyles';
import FormValidator from '../../infra/services/validations/FormValidator';
import styled from 'styled-components';
import TextInput from '../../components/inputs/TextInput';
import { titleH2, titleH3 } from '../../styles/TextSizes';
import { device } from '../../styles/Responsive';
import { weddingContractBrideFields, weddingContractGroomFields } from '../aboutUs/FormFields';
import CustomSelectInput from '../../components/inputs/CustomSelectInput';
import SelectLanguageInput from '../../components/inputs/SelectLanguageInput';
import SelectInput from '../../components/inputs/SelectInput';
import { weddingContractTypes } from './UtilWeddingContract';
import FilesInput from "../../components/inputs/FilesInput";
import CheckboxInput from '../../components/inputs/CheckboxInput';
import FileInput from '../../components/inputs/FileInput';
import { AddCoupleIdFiles, AddFirstPaymentProofIdFiles, GetPaymentPhasePriceByYear, RemoveCoupleIdFiles, RemoveFirstPaymentProofFiles, SaveWeddingContract } from '../../infra/requests/MyWeddingRequests';
import { isValidPhoneNumber } from 'react-phone-number-input';
import Alerts from '../../components/alert/Alert';
import { SpinLoading } from '../../styles/BasicStyles';
import { ProfileContainer } from '../profileReserve/ProfileStyles';
import { ReserveInfo, ReserveText, Title } from './ReserveStyles';
import { FormContainer } from './ReserveModal';
import SaveButton from '../../components/buttons/SaveButton';
import { bindActionCreators } from 'redux';
import { updateAboutUsAction } from "../../redux/Wedding/wedding.actions";
import { ConfirmReserve, GetReserve } from '../../infra/requests/ReserveRequests';
import WeddingContractDeclarationModal from '../../components/modals/WeddingContractDeclarationModal';
import moment from 'moment';
import CurrencyComponent from '../../components/currency/CurrencyComponent';
import { ReserveStatus } from './ReservePage';
import BudgetDescTextAreaInput from '../../components/inputs/BudgetDescTextAreaInput';
import { BillingUsersEnum } from '../budget/UtilBillingUsers';
import { getCountryOptions, getCountryTranslation } from '../../infra/services/utils/Countries';

export const BaseForm = styled(AntForm)`
  display: inline-block;
  width: 100%;
`;

export const SectionTitle = styled(titleH3)`
  text-align: left;
  padding-top: 105px;

  @media ${device.desktopL} {
    padding-top: 70px;
  }

  @media ${device.desktop} {
    padding-top: 50px;
  }
`;

export const SectionSubtitle = styled.div`
  text-align: left;
  padding-top: 15px;
  white-space: pre-line;
  color: #000000;
  font-size: 20px;
  font-weight: 400;
  line-height: 31px;
  margin-top: 40px;

  @media ${device.laptop} {
    font-size: 18px;
    line-height: 26px;
  }

  @media ${device.tablet} {
    font-size: 15px;
    line-height: 24px;
  }
`;

export const PaymentProofTitle = styled.div`
  text-align: left;
  padding-top: 15px;
  white-space: pre-line;
  color: #000000;
  font-size: 20px;
  font-weight: 400;
  line-height: 31px;

  @media ${device.laptop} {
    font-size: 18px;
    line-height: 26px;
  }

  @media ${device.tablet} {
    font-size: 15px;
    line-height: 24px;
  }
`;

export const PaymentProofContainer = styled.div`
    background-color: #f2f2f2;
    margin-top: 40px;
    padding: 20px;
    border-radius: 4px;
    border: 2px solid #e6e6e6;
`;

const validations = (values, props) => {
    let errors = {};

    // `recurrentWedding` é escrito no formulário com o valor devolvido pelo pedido da reserva
    // (ver getReserve). O estado do redux só é carregado no arranque da aplicação, pelo que numa
    // sessão antiga podia não ter a marcação de reincidência e o comprovativo não era exigido.
    const coupleAlreadyReserved = typeof values?.recurrentWedding === 'boolean'
        ? values.recurrentWedding
        : props?.wedding?.recurrentWedding === true;

    errors.bride = FormValidator.make({
        brideFullName: "required",
        brideNationality: "required",
        brideStreetDoorNumber: "required",
        brideZipCode: "required",
        brideStreet: "required",
        brideCountry: "required",
        bridePersonalEmail: "required|email",
        bridePersonalPhone: "required"
    })(values?.bride);

    errors.groom = FormValidator.make({
        groomFullName: "required",
        groomNationality: "required",
        groomStreetDoorNumber: "required",
        groomZipCode: "required",
        groomStreet: "required",
        groomCountry: "required",
        groomPersonalEmail: "required|email",
        groomPersonalPhone: "required"
    })(values?.groom);

    if (!values?.bride?.brideIdentification && !values?.bride?.brideIdentificationNumber) {
        errors.bride = {
            ...errors.bride,
            brideIdentification: 'ONE_OF_THESE_FIELDS_IS_REQUIRED',
            brideIdentificationNumber: 'ONE_OF_THESE_FIELDS_IS_REQUIRED'
        };
    }

    if (!values?.groom?.groomIdentification && !values?.groom?.groomIdentificationNumber) {
        errors.groom = {
            ...errors.groom,
            groomIdentification: 'ONE_OF_THESE_FIELDS_IS_REQUIRED',
            groomIdentificationNumber: 'ONE_OF_THESE_FIELDS_IS_REQUIRED'
        };
    }

    if (values?.bride?.bridePersonalPhone && !isValidPhoneNumber(values?.bride?.bridePersonalPhone)) {
        errors.bride.bridePersonalPhone = 'INVALID_PHONE_NUMBER_CONTRACT';
    }

    if (values?.groom?.groomPersonalPhone && !isValidPhoneNumber(values?.groom?.groomPersonalPhone)) {
        errors.groom.groomPersonalPhone = 'INVALID_PHONE_NUMBER_CONTRACT';
    }

    const brideIdentification = String(values?.bride?.brideIdentification)?.toLowerCase()?.trim();
    const groomIdentification = String(values?.groom?.groomIdentification)?.toLowerCase()?.trim();
    if (values?.bride?.brideIdentification && values?.groom?.groomIdentification && (brideIdentification === groomIdentification)) {
        errors.bride.brideIdentification = 'SAME_IDENTIFICATION_CONTRACT';
        errors.groom.groomIdentification = 'SAME_IDENTIFICATION_CONTRACT';
    }

    const brideIdentificationNumber = String(values?.bride?.brideIdentificationNumber)?.toLowerCase()?.trim();
    const groomIdentificationNumber = String(values?.groom?.groomIdentificationNumber)?.toLowerCase()?.trim();
    if (values?.bride?.brideIdentificationNumber && values?.groom?.groomIdentificationNumber && (brideIdentificationNumber === groomIdentificationNumber)) {
        errors.bride.brideIdentificationNumber = 'SAME_IDENTIFICATION_NUMBER_CONTRACT';
        errors.groom.groomIdentificationNumber = 'SAME_IDENTIFICATION_NUMBER_CONTRACT';
    }

    const bridePersonalEmail = String(values?.bride?.bridePersonalEmail)?.toLowerCase()?.trim();
    const groomPersonalEmail = String(values?.groom?.groomPersonalEmail)?.toLowerCase()?.trim();
    if (values?.bride?.bridePersonalEmail && values?.groom?.groomPersonalEmail && (bridePersonalEmail === groomPersonalEmail)) {
        errors.bride.bridePersonalEmail = 'SAME_EMAIL_CONTRACT';
        errors.groom.groomPersonalEmail = 'SAME_EMAIL_CONTRACT';
    }

    const bridePersonalPhone = String(values?.bride?.bridePersonalPhone)?.toLowerCase()?.trim();
    const groomPersonalPhone = String(values?.groom?.groomPersonalPhone)?.toLowerCase()?.trim();
    if (values?.bride?.bridePersonalPhone && values?.groom?.groomPersonalPhone && (bridePersonalPhone === groomPersonalPhone)) {
        errors.bride.bridePersonalPhone = 'SAME_PHONE_NUMBER_CONTRACT';
        errors.groom.groomPersonalPhone = 'SAME_PHONE_NUMBER_CONTRACT';
    }

    const errorsGeneral = FormValidator.make({
        contractLanguage: "required",
        contractType: "required",
        trueData: "required",
        brideContractFilesChecked: "required",
        groomContractFilesChecked: "required",
        coupleIdFiles: "required|min:1|max:6"
    })(values);

    if (values?.coupleIdFiles?.length === 0) {
        errorsGeneral['coupleIdFiles'] = 'INPUT_ERROR_REQUIRED';
    }

    if (coupleAlreadyReserved) {
        if (!values.paymentProofFile) {
            errors.paymentProofFile = 'INPUT_ERROR_REQUIRED';
        }

        if (!values.paymentProofDescription) {
            errors.paymentProofDescription = 'INPUT_ERROR_REQUIRED';
        }

        if (!values.paymentProofBillingUser) {
            errors.paymentProofBillingUser = 'INPUT_ERROR_REQUIRED';
        }

        if (values.paymentProofBillingUser) {
            if (!values.paymentProofBillingUserFullName) {
                errors.paymentProofBillingUserFullName = 'INPUT_ERROR_REQUIRED';
            }

            if (!values.paymentProofBillingUserIdentificationNumber) {
                errors.paymentProofBillingUserIdentificationNumber = 'INPUT_ERROR_REQUIRED';
            }

            if (!values.paymentProofBillingUserCountry) {
                errors.paymentProofBillingUserCountry = 'INPUT_ERROR_REQUIRED';
            }

            if (!values.paymentProofBillingUserNationality) {
                errors.paymentProofBillingUserNationality = 'INPUT_ERROR_REQUIRED';
            }

            if (!values.paymentProofBillingUserStreetDoorNumber) {
                errors.paymentProofBillingUserStreetDoorNumber = 'INPUT_ERROR_REQUIRED';
            }

            if (!values.paymentProofBillingUserZipCode) {
                errors.paymentProofBillingUserZipCode = 'INPUT_ERROR_REQUIRED';
            }

            if (!values.paymentProofBillingUserStreet) {
                errors.paymentProofBillingUserStreet = 'INPUT_ERROR_REQUIRED';
            }
        }
    }

    errors = { ...errors, ...errorsGeneral };

    return errors;
};

class WeddingContractPage extends React.Component {
    state = {
        wedding: {},
        ready: false,
        loading: false,
        selectedBillingUser: null,
        showDeclarationModal: false,
        contractDeclaration: null,
        firstPhasePrice: null,
        recurrentWedding: null
    }

    componentDidMount() {
        const { initialValues, history, match: { params } } = this.props;

        if (!params?.id) {
            return history.goBack();
        }

        document.body.style.overflowY = "auto";
        window.scroll({ top: 0, left: 0, behavior: "smooth" });

        this.getReserve();
    }


    getReserve = async () => {
        const { match: { params }, history, wedding, change } = this.props;

        const result = await GetReserve(params.id);

        if (result?.success) {
            const now = moment.utc();
            const reserveIsActive = now.isSameOrBefore(moment.utc(result?.data.endActivationDate));

            if (reserveIsActive
                && result?.data?.status == ReserveStatus.RSC) {
                // Valor atual da reincidência, vindo do servidor neste pedido, para não depender
                // do estado carregado no arranque da aplicação
                const recurrentWedding = typeof result?.data?.recurrentWedding === 'boolean'
                    ? result.data.recurrentWedding
                    : wedding?.recurrentWedding === true;
                change('recurrentWedding', recurrentWedding);

                this.setState({
                    reserve: result?.data,
                    ready: true,
                    showDeclarationModal: true,
                    recurrentWedding
                });

                const year = moment.utc(result?.data?.date).year();
                const priceResult = await GetPaymentPhasePriceByYear(year);
                if (priceResult?.success) {
                    this.setState({ firstPhasePrice: priceResult?.data?.firstPhasePrice });
                }
            } else {
                return history.goBack();
            }

        } else {
            return history.goBack();
        }
    }

    translateContractTypes = (contractType) => {
        const { translate } = this.props;
        return translate(contractType.name);
    }

    handleFileAdd = async file => {
        const payload = new FormData();
        payload.append("image", file);
        return await AddCoupleIdFiles(payload);
    };

    handleFileDelete = async id => {
        return await RemoveCoupleIdFiles(id);
    };

    handleFirstPaymentProofFileAdd = async file => {
        const payload = new FormData();
        payload.append("image", file);
        return await AddFirstPaymentProofIdFiles(payload);
    };

    handleFirstPaymentProofFileDelete = async id => {
        return await RemoveFirstPaymentProofFiles(id);
    };

    handleDeclarationConfirm = (declarationData) => {
        this.setState({ showDeclarationModal: false, contractDeclaration: declarationData });
    };

    isRecurrentWedding = () => {
        const { wedding } = this.props;
        const { recurrentWedding } = this.state;
        return recurrentWedding === null
            ? wedding?.recurrentWedding === true
            : recurrentWedding;
    }

    onSubmit = async (values) => {
        const { translate, history, dispatch, wedding } = this.props;
        const { reserve, contractDeclaration } = this.state;
        this.setState({ loading: true });

        values.contractDeclarationId = contractDeclaration;

        if (this.isRecurrentWedding()) {
            values.firstPaymentProof = {
                file: values?.paymentProofFile,
                description: values?.paymentProofDescription,
                billing: {
                    user: values?.paymentProofBillingUser,
                    country: values?.paymentProofBillingUserCountry,
                    fullName: values?.paymentProofBillingUserFullName,
                    identificationNumber: values?.paymentProofBillingUserIdentificationNumber,
                    nationality: values?.paymentProofBillingUserNationality,
                    street: values?.paymentProofBillingUserStreet,
                    streetDoorNumber: values?.paymentProofBillingUserStreetDoorNumber,
                    zipCode: values?.paymentProofBillingUserZipCode
                }
            }
        }

        const result = await ConfirmReserve(reserve._id, values);

        if (result?.success) {
            Alerts.new({
                type: "success",
                title: translate("SUCCESS"),
                text: translate('WEDDING_SUBMITTED_CONTRACT'),
            });
            //  window.location.reload(true);
            dispatch(updateAboutUsAction(result?.data?.wedding));
            this.setState({ loading: false }, () => {
                return history.push('/confirmations')
            });
        } else {
            if (
                result?.data === "ERROR_DATE_OCCUPIED" ||
                result?.data === "ERROR_CANT_CONFIRM" ||
                result?.data === "ERROR_DATE_UNAVAILABLE" ||
                result?.data === "NOT_AUTHORIZED" ||
                result?.data === "ERROR_PAYMENT_PROOF_REQUIRED"
            ) {
                Alerts.new({
                    type: "error",
                    title: translate("ERROR"),
                    text: translate(result?.data),
                });
            } else {
                Alerts.new({
                    type: "error",
                    title: translate("ERROR"),
                    text: result?.data,
                });
            }

            // Falta o comprovativo: mantém o casal no formulário para o poder carregar,
            // garantindo que a secção do comprovativo passa a estar visível
            if (result?.data === "ERROR_PAYMENT_PROOF_REQUIRED") {
                this.props.change('recurrentWedding', true);
                return this.setState({ loading: false, recurrentWedding: true });
            }

            return history.goBack();
        }

    };

    getPax = () => {
        const { reserve } = this.state;
        const now = moment.utc();
        const reserveIsActive = now.isSameOrBefore(
            moment.utc(reserve.endActivationDate)
        );
        return reserveIsActive
            ? reserve.priceObj.minPax
            : reserve.price.minPax;
    }

    getPrice = () => {
        const { reserve } = this.state;
        const now = moment.utc();
        const reserveIsActive = now.isSameOrBefore(
            moment.utc(reserve.endActivationDate)
        );
        return reserveIsActive
            ? reserve.priceObj.minPrice
            : reserve.price.minPrice;
    }

    getTotal = () => {
        const { reserve } = this.state;
        const now = moment.utc();
        const reserveIsActive = now.isSameOrBefore(
            moment.utc(reserve.endActivationDate)
        );
        const price = reserveIsActive
            ? reserve.priceObj?.minPrice
            : reserve.price?.minPrice;
        const pax = reserveIsActive
            ? reserve.priceObj?.minPax
            : reserve.price?.minPax;

        return Number((price * pax).toFixed(2))
    }

    getBillingUsers = () => {
        const { wedding } = this.props;

        const billingUsers = [
            {
                _id: BillingUsersEnum.GROOM,
                name: this.props?.groomFullName || this.props?.groomName,
                user: BillingUsersEnum.GROOM
            },
            {
                _id: BillingUsersEnum.BRIDE,
                name: this.props?.brideFullName || this.props?.brideName,
                user: BillingUsersEnum.BRIDE
            },
        ];

        if (wedding?.otherUserBillingList?.length > 0) {
            wedding.otherUserBillingList.forEach((element) => {
                billingUsers.push({
                    _id: element.fullName,
                    name: element.fullName,
                    user: BillingUsersEnum.OTHER
                });
            });
        }

        billingUsers.push({ _id: BillingUsersEnum.OTHER, name: 'OTHER', user: BillingUsersEnum.OTHER });

        return billingUsers;
    };

    renderBudgetDetailsOnPaymentProofUpload = () => {
        const { translate, info } = this.props;
        return <div style={{ marginTop: '20px' }}>
            <ul>
                <li style={{ display: 'flex', justifyContent: 'start' }}><b>{translate('PAYMENT_DATA')}</b></li>

                <li style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
                    <div style={{ textDecoration: 'underline' }}>{translate('ZONE_NAME')}:</div>
                    <span>{info?.configs?.local === 1 ? 'Solar da Levada' : info?.configs?.local === 2 ? 'Quinta Lago dos Cisnes' : ''}</span>
                </li>

                <li style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
                    <div style={{ textDecoration: 'underline' }}>{translate('IBAN')}:</div>
                    <span>{info?.configs?.iban || ''}</span>
                </li>

                <li style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
                    <div style={{ textDecoration: 'underline' }}>{translate('SWIFT_CODE')}:</div>
                    <span>{info?.configs?.swift || ''}</span>
                </li>

                <li style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
                    <div style={{ textDecoration: 'underline' }}>{translate('BANK')}:</div>
                    <span>Crédito Agrícola</span>
                </li>

                {this.state.firstPhasePrice != null && (
                    <li style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
                        <div style={{ textDecoration: 'underline' }}>{translate('AMOUNT_FIRST_PHASE')}:</div>
                        <span>{this.state.firstPhasePrice}€</span>
                    </li>
                )}
            </ul>
        </div>;
    }

    onBillingUserSelect = (billingUser) => {
        const {
            change,

            paymentProofGroomName,
            paymentProofGroomFullName,
            paymentProofGroomNationality,
            paymentProofGroomIdentificationNumber,
            paymentProofGroomStreetDoorNumber,
            paymentProofGroomZipCode,
            paymentProofGroomStreet,
            paymentProofGroomCountry,

            paymentProofBrideName,
            paymentProofBrideFullName,
            paymentProofBrideNationality,
            paymentProofBrideIdentificationNumber,
            paymentProofBrideStreetDoorNumber,
            paymentProofBrideZipCode,
            paymentProofBrideStreet,
            paymentProofBrideCountry,
        } = this.props;

        this.setState({ selectedBillingUser: billingUser });

        if (billingUser === BillingUsersEnum.GROOM) {
            change('paymentProofBillingUserFullName', paymentProofGroomFullName || '');
            change('paymentProofBillingUserNationality', paymentProofGroomNationality || '');
            change('paymentProofBillingUserIdentificationNumber', paymentProofGroomIdentificationNumber || '');
            change('paymentProofBillingUserStreetDoorNumber', paymentProofGroomStreetDoorNumber || '');
            change('paymentProofBillingUserZipCode', paymentProofGroomZipCode || '');
            change('paymentProofBillingUserStreet', paymentProofGroomStreet || '');
            change('paymentProofBillingUserCountry', paymentProofGroomCountry || '');
        } else if (billingUser === BillingUsersEnum.BRIDE) {
            change('paymentProofBillingUserFullName', paymentProofBrideFullName || '');
            change('paymentProofBillingUserNationality', paymentProofBrideNationality || '');
            change('paymentProofBillingUserIdentificationNumber', paymentProofBrideIdentificationNumber || '');
            change('paymentProofBillingUserStreetDoorNumber', paymentProofBrideStreetDoorNumber || '');
            change('paymentProofBillingUserZipCode', paymentProofBrideZipCode || '');
            change('paymentProofBillingUserStreet', paymentProofBrideStreet || '');
            change('paymentProofBillingUserCountry', paymentProofBrideCountry || '');
        } else {
            change('paymentProofBillingUserFullName', '');
            change('paymentProofBillingUserNationality', '');
            change('paymentProofBillingUserIdentificationNumber', '');
            change('paymentProofBillingUserStreetDoorNumber', '');
            change('paymentProofBillingUserZipCode', '');
            change('paymentProofBillingUserStreet', '');
            change('paymentProofBillingUserCountry', '');
        }
    };

    render() {
        const { translate, activeLanguage } = this.props;
        const { handleSubmit, submitFailed, invalid, dirty, submitting } = this.props;
        const { loading, ready, showDeclarationModal } = this.state;
        const { wedding, trueData, initialValues } = this.props;
        const { reserve } = this.state;

        if (!ready) return <SpinLoading />;

        return (
            <ProfileContainer>
                <WeddingContractDeclarationModal
                    isOpen={showDeclarationModal}
                    reserveId={reserve?._id}
                    language={activeLanguage?.code || 'pt'}
                    onConfirm={this.handleDeclarationConfirm}
                />
                <Title style={{ marginBottom: 10 }}>{translate("RESERVE_INFO_CONTRACT")}</Title>
                <ReserveInfo>
                    <ReserveText>
                        <b>{translate('DATE')}:</b>
                        {moment.utc(reserve?.date).format('DD/MM/YYYY')}
                    </ReserveText>
                    <ReserveText>
                        <b>{translate('WEDDING_PLACE')}:</b>
                        {reserve?.weddingPlace == 2 ? 'Quinta Lago dos Cisnes' : 'Solar da Levada'}
                    </ReserveText>
                    <ReserveText>
                        <b>{translate('PAX')}:</b>
                        {this.getPax()}
                    </ReserveText>
                    <ReserveText>
                        <b>{translate('PRICE')}:</b>
                        <CurrencyComponent value={this.getPrice()} />
                    </ReserveText>
                    <ReserveText>
                        <b>{translate('MINIMUM_GLOBAL_PRICE')}:</b>
                        <CurrencyComponent value={this.getTotal()} />
                    </ReserveText>
                </ReserveInfo>


                <Title style={{ marginTop: 30 }}>{translate("COUPLE_INFO_CONTRACT")}</Title>
                <FormContainer onSubmit={handleSubmit(this.onSubmit)}>
                    <Field
                        component={SelectLanguageInput}
                        name={'contractLanguage'}
                        type={'select'}
                        label={`${translate('WEDDING_LANGUAGE_CONTRACT')} *`}
                    />

                    <Field
                        component={SelectInput}
                        name={'contractType'}
                        data={weddingContractTypes.filter(wc => !wc.deprecated)}
                        type={'select'}
                        costumeLabel={this.translateContractTypes}
                        label={`${translate('CONTRACT_TYPE_CONTRACT')} *`}
                    />
                    <div style={{ marginTop: '10px', fontSize: '14px', textAlign: 'justify' }}>{translate('CONTRACT_TYPE_INFO_MESSAGE')}</div>

                    <Row gutter={[12, 12]}>
                        <FormSection name="bride">
                            <SectionSubtitle>{translate('GROOM_BRIDE_WEDDING_CONTRACT')}</SectionSubtitle>
                            {weddingContractBrideFields.map((field, key) => (
                                <Col key={key} xs={field?.xs || 24} sm={field?.sm || 24} md={field?.md || 24} lg={field?.lg || 24} xl={field?.xl || 24}>
                                    <Field
                                        key={field.name}
                                        component={field.component}
                                        name={field.name}
                                        type={field.type}
                                        data={field?.dataOptions}
                                        dataKey={field?.dataKey}
                                        costumeLabel={(country) => field?.costumeLabel(activeLanguage, country)}
                                        disabled={field?.disabled}
                                        label={
                                            field.asterisc
                                                ? `${translate(field.label)} *`
                                                : translate(field.label)
                                        }
                                    />
                                </Col>
                            ))}
                        </FormSection>
                    </Row>

                    <Row gutter={[12, 12]}>
                        <FormSection name="groom">
                            <SectionSubtitle>{translate('GROOM_BRIDE_WEDDING_CONTRACT')}</SectionSubtitle>
                            {weddingContractGroomFields.map((field, key) => (
                                <Col key={key} xs={field?.xs || 24} sm={field?.sm || 24} md={field?.md || 24} lg={field?.lg || 24} xl={field?.xl || 24}>
                                    <Field
                                        key={field.name}
                                        component={field.component}
                                        name={field.name}
                                        type={field.type}
                                        data={field?.dataOptions}
                                        dataKey={field?.dataKey}
                                        costumeLabel={(country) => field?.costumeLabel(activeLanguage, country)}
                                        disabled={field?.disabled}
                                        label={
                                            field.asterisc
                                                ? `${translate(field.label)} *`
                                                : translate(field.label)
                                        }
                                    />
                                </Col>
                            ))}
                        </FormSection>
                    </Row>

                    {this.isRecurrentWedding() && <PaymentProofContainer><Row gutter={[12, 12]}>
                        <PaymentProofTitle>Comprovativo de pagamento</PaymentProofTitle>

                        {this.renderBudgetDetailsOnPaymentProofUpload()}

                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Field
                                disabled={false}
                                component={FilesInput}
                                name={'paymentProofFile'}
                                label={`${translate('UPLOAD_PAYMENT_PROOF_FILE')} *`}
                                translate={translate}
                                maxFiles={1}
                                handleDelete={this.handleFirstPaymentProofFileDelete}
                                handleAdd={this.handleFirstPaymentProofFileAdd}
                                accept={['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']}
                            />
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Field
                                disabled={false}
                                component={BudgetDescTextAreaInput}
                                name={'paymentProofDescription'}
                                label={`${translate('DESCRIPTION')} *`}
                                placeholder={translate('DESCRIPTION_PAYMENT_PROOF')}
                                inForm={true}
                                readOnly={false}
                            />
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Field
                                disabled={false}
                                component={SelectInput}
                                name={'paymentProofBillingUser'}
                                data={this.getBillingUsers()}
                                costumeLabel={(userBilling) => (userBilling.name === 'OTHER') ? translate(userBilling.name) : userBilling.name}
                                label={`${translate('BILLING_USER')} *`}
                                onChange={(billingUser) => this.onBillingUserSelect(billingUser)}
                            />

                            {this.state.selectedBillingUser && (
                                <React.Fragment>
                                    <Field
                                        disabled={false}
                                        component={TextInput}
                                        name={'paymentProofBillingUserFullName'}
                                        type={'text'}
                                        label={`${translate('FULLNAME_CONTRACT')} *`}
                                    />
                                    <Field
                                        disabled={false}
                                        component={SelectInput}
                                        name={'paymentProofBillingUserNationality'}
                                        data={getCountryOptions()}
                                        dataKey={'value'}
                                        costumeLabel={(country) => getCountryTranslation(activeLanguage, country)}
                                        label={`${translate('NATIONALITY_CONTRACT')} *`}
                                    />
                                    <Field
                                        disabled={false}
                                        component={TextInput}
                                        name={'paymentProofBillingUserIdentificationNumber'}
                                        type={'text'}
                                        label={`${translate('IDENTIFICATION_NUMBER_CONTRACT')} *`}
                                    />
                                    <Field
                                        disabled={false}
                                        component={TextInput}
                                        name={'paymentProofBillingUserStreetDoorNumber'}
                                        type={'text'}
                                        label={`${translate('STREET_DOOR_CONTRACT')} *`}
                                    />
                                    <Field
                                        disabled={false}
                                        component={TextInput}
                                        name={'paymentProofBillingUserZipCode'}
                                        type={'text'}
                                        label={`${translate('ZIP_CODE_CONTRACT')} *`}
                                    />
                                    <Field
                                        disabled={false}
                                        component={TextInput}
                                        name={'paymentProofBillingUserStreet'}
                                        type={'text'}
                                        label={`${translate('STREET_CONTRACT')} *`}
                                    />
                                    <Field
                                        disabled={false}
                                        component={SelectInput}
                                        name={'paymentProofBillingUserCountry'}
                                        data={getCountryOptions()}
                                        dataKey={'value'}
                                        costumeLabel={(country) => getCountryTranslation(activeLanguage, country)}
                                        label={`${translate('COUNTRY_CONTRACT')} *`}
                                    />
                                </React.Fragment>
                            )}
                        </Col>
                    </Row></PaymentProofContainer>}

                    <Field
                        component={FilesInput}
                        name={"coupleIdFiles"}
                        label={`${translate('WEDDING_FILES_CONTRACT')} *`}
                        handleDelete={this.handleFileDelete}
                        handleAdd={this.handleFileAdd}
                        maxFiles={6}
                        accept={['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']}
                    />

                    <Field
                        component={CheckboxInput}
                        name={'brideContractFilesChecked'}
                        label={`${translate('ATTACHED_DOCS_OF')} ${this.props?.brideName || translate('BRIDE')}`}
                    />

                    <Field
                        component={CheckboxInput}
                        name={'groomContractFilesChecked'}
                        label={`${translate('ATTACHED_DOCS_OF')} ${this.props?.groomName || translate('GROOM')}`}
                    />

                    {wedding?.alternativeGuest && wedding?.alternativeGuest?.email?.trim() !== '' && <Field
                        component={CheckboxInput}
                        name={'validateThirdEmail'}
                        label={translate('VALIDATE_THIRD_EMAIL_CONTACT')}
                    />}

                    <Field
                        component={CheckboxInput}
                        name={'trueData'}
                        label={translate('VALIDATE_TRUE_DATA_CONTACT')}
                    />
                    {trueData && <SaveButton
                        htmlType="submit"
                        error={submitFailed && invalid}
                        text={translate("SAVE")}
                        textMobile={translate("SAVE")}
                        // onClick={() => this.setState({ goToNextPage: true })}
                        loading={loading}
                    />}
                </FormContainer>
            </ProfileContainer>
        )
    }
};

const selector = formValueSelector('wedding_contract_form');

WeddingContractPage = reduxForm({
    form: 'wedding_contract_form',
    validate: validations
})(WeddingContractPage);

const mapStateToProps = state => ({
    configs: state.info.configs,
    info: state.info,
    wedding: state.wedding.wedding,
    initialValues: {
        ...state.wedding.wedding,
        bride: {
            brideFullName: state?.wedding?.wedding?.bride?.fullName,
            brideNationality: state?.wedding?.wedding?.bride?.nationality,
            brideIdentification: state?.wedding?.wedding?.bride?.identification,
            brideIdentificationNumber: state?.wedding?.wedding?.bride?.identificationNumber,
            brideStreetDoorNumber: state?.wedding?.wedding?.bride?.streetDoorNumber,
            brideZipCode: state?.wedding?.wedding?.bride?.zipCode,
            brideStreet: state?.wedding?.wedding?.bride?.street,
            brideCountry: state?.wedding?.wedding?.bride?.country,
            brideEmail: state?.wedding?.wedding?.bride?.email,
            bridePersonalEmail: state?.wedding?.wedding?.bride?.personalEmail,
            brideContact: state?.wedding?.wedding?.bride?.contact,
            bridePersonalPhone: state?.wedding?.wedding?.bride?.personalPhone,
        },
        groom: {
            groomFullName: state?.wedding?.wedding?.groom?.fullName,
            groomNationality: state?.wedding?.wedding?.groom?.nationality,
            groomIdentification: state?.wedding?.wedding?.groom?.identification,
            groomIdentificationNumber: state?.wedding?.wedding?.groom?.identificationNumber,
            groomStreetDoorNumber: state?.wedding?.wedding?.groom?.streetDoorNumber,
            groomZipCode: state?.wedding?.wedding?.groom?.zipCode,
            groomStreet: state?.wedding?.wedding?.groom?.street,
            groomCountry: state?.wedding?.wedding?.groom?.country,
            groomEmail: state?.wedding?.wedding?.groom?.email,
            groomPersonalEmail: state?.wedding?.wedding?.groom?.personalEmail,
            groomContact: state?.wedding?.wedding?.groom?.contact,
            groomPersonalPhone: state?.wedding?.wedding?.groom?.personalPhone,
        },
        validateThirdEmail: false,
        trueData: false,
        brideContractFilesChecked: false,
        groomContractFilesChecked: false
    },
    paymentProof: {
        file: state.wedding.paymentProofFile,
        description: state.wedding.paymentProofDescription,
        billing: {
            user: state.wedding.paymentProofBillingUser,
            fullName: state.wedding.paymentProofBillingUserFullName,
            nationality: state.wedding.paymentProofBillingUserNationality,
            identificationNumber: state.wedding.paymentProofBillingUserIdentificationNumber,
            streetDoorNumber: state.wedding.paymentProofBillingUserStreetDoorNumber,
            zipCode: state.wedding.paymentProofBillingUserZipCode,
            street: state.wedding.paymentProofBillingUserStreet,
            country: state.wedding.paymentProofBillingUserCountry
        }
    },
    paymentProofBrideFullName: selector(state, 'bride.brideFullName'),
    paymentProofBrideNationality: selector(state, 'bride.brideNationality'),
    paymentProofBrideIdentificationNumber: selector(state, 'bride.brideIdentificationNumber'),
    paymentProofBrideStreetDoorNumber: selector(state, 'bride.brideStreetDoorNumber'),
    paymentProofBrideZipCode: selector(state, 'bride.brideZipCode'),
    paymentProofBrideStreet: selector(state, 'bride.brideStreet'),
    paymentProofBrideCountry: selector(state, 'bride.brideCountry'),
    paymentProofGroomFullName: selector(state, 'groom.groomFullName'),
    paymentProofGroomNationality: selector(state, 'groom.groomNationality'),
    paymentProofGroomIdentificationNumber: selector(state, 'groom.groomIdentificationNumber'),
    paymentProofGroomStreetDoorNumber: selector(state, 'groom.groomStreetDoorNumber'),
    paymentProofGroomZipCode: selector(state, 'groom.groomZipCode'),
    paymentProofGroomStreet: selector(state, 'groom.groomStreet'),
    paymentProofGroomCountry: selector(state, 'groom.groomCountry'),

    coupleIdFiles: state.wedding.coupleIdFiles,
    brideFullName: selector(state, 'brideFullName'),
    brideNationality: selector(state, 'brideNationality'),
    brideIdentification: selector(state, 'brideIdentification'),
    brideIdentificationNumber: selector(state, 'brideIdentificationNumber'),
    brideStreetDoorNumber: selector(state, 'brideStreetDoorNumber'),
    brideZipCode: selector(state, 'brideZipCode'),
    brideStreet: selector(state, 'brideStreet'),
    brideCountry: selector(state, 'brideCountry'),
    brideEmail: selector(state, 'brideEmail'),
    bridePersonalEmail: selector(state, 'bridePersonalEmail'),
    brideContact: selector(state, 'brideContact'),
    bridePersonalPhone: selector(state, 'bridePersonalPhone'),
    groomFullName: selector(state, 'groomFullName'),
    groomNationality: selector(state, 'groomNationality'),
    groomIdentification: selector(state, 'groomIdentification'),
    groomIdentificationNumber: selector(state, 'groomIdentificationNumber'),
    groomStreetDoorNumber: selector(state, 'groomStreetDoorNumber'),
    groomZipCode: selector(state, 'groomZipCode'),
    groomStreet: selector(state, 'groomStreet'),
    groomCountry: selector(state, 'groomCountry'),
    groomEmail: selector(state, 'groomEmail'),
    groomPersonalEmail: selector(state, 'groomPersonalEmail'),
    groomContact: selector(state, 'groomContact'),
    groomPersonalPhone: selector(state, 'groomPersonalPhone'),
    trueData: selector(state, 'trueData'),
    brideName: selector(state, 'bride.brideFullName'),
    groomName: selector(state, 'groom.groomFullName'),
});

const mapActionToProps = (dispatch) =>
    bindActionCreators({ updateAboutUsAction, change }, dispatch);

export default withLocalize(connect(mapStateToProps, mapActionToProps)(WeddingContractPage))